/* @flow */
import * as React from 'react';

const Weight = props => (
  <svg width={32} height={16} viewBox="0 0 32 16" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFF055"
      fillRule="evenodd"
      d="M31,5 L29,5 L29,1 C29,0.448 28.553,0 28,0 L24,0 C23.447,0 23,0.448 23,1 L23,7 L9,7 L9,1 C9,0.448 8.553,0 8,0 L4,0 C3.447,0 3,0.448 3,1 L3,5 L1,5 C0.447,5 0,5.448 0,6 L0,10 C0,10.552 0.447,11 1,11 L3,11 L3,15 C3,15.552 3.447,16 4,16 L8,16 C8.553,16 9,15.552 9,15 L9,9 L23,9 L23,15 C23,15.552 23.447,16 24,16 L28,16 C28.553,16 29,15.552 29,15 L29,11 L31,11 C31.553,11 32,10.552 32,10 L32,6 C32,5.448 31.553,5 31,5 Z M2,9 L2,7 L3,7 L3,9 L2,9 Z M7,14 L5,14 L5,2 L7,2 L7,14 Z M27,14 L25,14 L25,2 L27,2 L27,14 Z M30,9 L29,9 L29,7 L30,7 L30,9 Z"
    />
  </svg>
);

export default Weight;



// WEBPACK FOOTER //
// ./src/assets/images/icons/weight.js